var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPublic !== null)?_c('v-app',[_c('Navbar'),_c('v-content',[(_vm.isPublic)?_c('router-view'):_c('Login')],1),(_vm.$route.name !== 'result')?_c('Footer'):_vm._e(),_c('Notification')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }